import { fetchAssignmentTypeList } from "@/services/assignmentType";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useQuery } from "@tanstack/react-query";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface AssignmentTypeSelectProps extends ControllerRenderProps {
  className?: string;
}

export default forwardRef<HTMLButtonElement, AssignmentTypeSelectProps>(
  function AssignmentTypeSelect(props, ref) {
    const { t } = useTranslation();

    const query = useQuery({
      queryKey: ["assignmentTypes"],
      queryFn: () => fetchAssignmentTypeList(),
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    });

    if (query.isLoading) {
      return (
        <Select disabled>
          <SelectTrigger className={props.className || "w-full"}>
            <SelectValue
              placeholder={t("structureAssignments.loading.assignmentTypes")}
            />
          </SelectTrigger>
        </Select>
      );
    }

    if (query.isError) {
      return (
        <Select disabled>
          <SelectTrigger className={props.className || "w-full"}>
            <SelectValue
              placeholder={t("structureAssignments.loading.error")}
            />
          </SelectTrigger>
        </Select>
      );
    }

    return (
      <Select
        onValueChange={props.onChange}
        value={props.value}
        disabled={props.disabled}
      >
        <SelectTrigger className={props.className || "w-full"} ref={ref}>
          <SelectValue
            placeholder={t("structureAssignments.placeholders.assignment_type")}
          />
        </SelectTrigger>
        <SelectContent>
          {query.data?.map((type) => (
            <SelectItem key={type} value={type}>
              {t(`structureAssignments.enum.assignmentType.${type}`, type)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);
